import React from 'react';
import { Modal, Spin } from 'antd';
import {LoadingOutlined} from "@ant-design/icons";

const LoadingService = {

   

    modal: null,
    show: () => {
        LoadingService.modal = Modal.info({
            content: (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <LoadingOutlined style={{ fontSize: 24 }} spin />
                </div>
            ),
            closable: false,
            maskClosable: false,
            keyboard: false,
            centered: true,
            width :'70px',
            okButtonProps: { style: { display: 'none' } },
            cancelButtonProps: { style: { display: 'none' } }, // Hide the Cancel button
            icon: null, // Remove the icon
            footer: null, // Remove the footer buttons
        });
    },
    hide: () => {
        if (LoadingService.modal) {
            LoadingService.modal.destroy();
            LoadingService.modal = null;
        }
    },
};

export default LoadingService;
